import { render } from "./Counter.vue?vue&type=template&id=2fa07d78&scoped=true"
import script from "./Counter.vue?vue&type=script&lang=js"
export * from "./Counter.vue?vue&type=script&lang=js"

import "./Counter.vue?vue&type=style&index=0&id=2fa07d78&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa07d78"]])

export default __exports__